module.exports = __webpack_public_path__ + "img/gbprime.61239afd.svg";